(function () {
  'use strict';

  var BUNDLE_HANDLE = 'custom-7-box-tea-bundle';
  var BUILDER_URL = '/pages/tea-pod-bundles-subscribe';
  var FULFILLMENT_KEY_RE = /^(Item \d+|Pick \d+|Fulfillment SKUs|Bundle contents)\s*:/;

  function isFulfillmentText(text) {
    if (!text) return false;
    var t = text.trim();
    if (!t) return false;
    return (
      FULFILLMENT_KEY_RE.test(t) ||
      t.indexOf('Fulfillment SKUs') === 0 ||
      t.indexOf('Bundle contents') === 0 ||
      /^Item \d+:/.test(t) ||
      /^Pick \d+:/.test(t) ||
      (t.indexOf(' — ') !== -1 && t.indexOf('K-Cups') !== -1 && t.indexOf('TV') === 0)
    );
  }

  function looksLikeBundleItem(el) {
    if (!el) return false;
    if (el.classList.contains('cart-item--ssp-bundle-minicart')) return true;
    if (el.getAttribute('product-handle') === BUNDLE_HANDLE) return true;
    var text = el.textContent || '';
    if (text.indexOf('Fulfillment SKUs') !== -1) return true;
    if (text.indexOf('Pick 1:') !== -1 && text.indexOf('Item 1:') !== -1) return true;
    if (text.indexOf('Bundle contents:') !== -1) return true;
    return false;
  }

  function subscriptionLabel(el) {
    var plan = '';
    el.querySelectorAll('.product-option, p.product-option').forEach(function (node) {
      var t = (node.textContent || '').trim();
      if (!t || isFulfillmentText(t)) return;
      if (/subscription/i.test(t)) {
        plan = t.replace(/^·\s*/, '');
      }
    });
    return plan;
  }

  function ensureSummary(el, plan) {
    var variantArea = el.querySelector('.minicart__item-variant, .cart-options');
    if (!variantArea) return;
    if (variantArea.querySelector('.ssp-minicart-summary')) return;
    var summary = document.createElement('div');
    summary.className = 'product-option dark-grey fs-small ssp-minicart-summary';
    var parts = ['7 flavors', '84 K-Cups'];
    if (plan) parts.push(plan);
    summary.textContent = parts.join(' · ');
    variantArea.insertBefore(summary, variantArea.firstChild);
  }

  function stripFulfillmentNodes(el) {
    var propWrap = el.querySelector('.product-option-property');
    if (propWrap) propWrap.remove();

    el.querySelectorAll('.product-option, .cart-options > div').forEach(function (opt) {
      if (opt.classList.contains('ssp-minicart-summary')) return;
      var t = (opt.textContent || '').trim();
      if (isFulfillmentText(t) || /^Item \d+\./.test(t)) {
        opt.remove();
      }
    });
  }

  function cleanThemeMinicartItem(el) {
    if (!looksLikeBundleItem(el)) return false;

    el.classList.add('cart-item--ssp-bundle-minicart');

    var plan = subscriptionLabel(el);
    var nameLink = el.querySelector('.minicart__product-name a, .minicart__product-name');
    if (nameLink) {
      nameLink.textContent = 'Seven Teas Build-a-Box';
      if (nameLink.tagName === 'A') {
        nameLink.setAttribute('href', BUILDER_URL);
        nameLink.setAttribute('aria-label', 'Seven Teas Build-a-Box');
      }
    }

    var imageLink = el.querySelector('.minicart__product__image a');
    if (imageLink) {
      imageLink.setAttribute('href', BUILDER_URL);
      imageLink.setAttribute('aria-label', 'Seven Teas Build-a-Box');
    }

    stripFulfillmentNodes(el);
    ensureSummary(el, plan);
    return true;
  }

  function cleanOcuDrawer(root) {
    var scope = root || document;
    scope.querySelectorAll('.ocu-cart-drawer [class*="item"], .ocu-cart-drawer [class*="line"]').forEach(function (el) {
      var text = el.textContent || '';
      if (text.indexOf('Fulfillment SKUs') === -1 && text.indexOf('Pick 1:') === -1) return;

      el.querySelectorAll('p, li, div, span').forEach(function (node) {
        if (!isFulfillmentText(node.textContent)) return;
        var row = node.closest('[class*="propert"]') || node.closest('p') || node.closest('li');
        if (row && row !== el && row.parentNode) row.parentNode.removeChild(row);
      });

      var title = el.querySelector('[class*="title"], [class*="name"], h3, h4, a');
      if (title) title.textContent = 'Seven Teas Build-a-Box';

      if (!el.querySelector('.ssp-minicart-summary')) {
        var summary = document.createElement('div');
        summary.className = 'ssp-minicart-summary dark-grey fs-small';
        summary.textContent = '7 flavors · 84 K-Cups · Monthly Subscription';
        var info = el.querySelector('[class*="info"], [class*="details"]') || el;
        info.appendChild(summary);
      }
    });
  }

  function run(root) {
    var scope = root || document;
    scope
      .querySelectorAll(
        '#minicart-form .cart-item, #header__minicart .cart-item, .header__minicart .cart-item, .minicart .items .cart-item'
      )
      .forEach(cleanThemeMinicartItem);
    cleanOcuDrawer(scope);
  }

  function injectStyles() {
    if (document.getElementById('teavity-minicart-bundle-clean-css')) return;
    var style = document.createElement('style');
    style.id = 'teavity-minicart-bundle-clean-css';
    style.textContent =
      '.cart-item--ssp-bundle-minicart .product-option-property,' +
      '.cart-item--ssp-bundle-minicart .product-option:not(.ssp-minicart-summary){display:none!important}' +
      '.cart-item--ssp-bundle-minicart .ssp-minicart-summary{display:block!important}';
    document.head.appendChild(style);
  }

  function observe() {
    injectStyles();
    run();
    var timer = null;
    var obs = new MutationObserver(function () {
      if (timer) return;
      timer = window.setTimeout(function () {
        timer = null;
        run();
      }, 80);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  document.addEventListener('cart:updated', function () {
    run();
  });
  document.addEventListener('cart:refresh', function () {
    run();
  });
})();
